/**
 * L'accueil, « Ma journée » : l'onglet `dashboard` de la coquille. Chargé à son premier rendu.
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { type TutorSpaceTabTable } from "../tutorSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const homeTabs: TutorSpaceTabTable<"home"> = {
    dashboard: loadedOnRender(() => require("./TutorHomeScreen").TutorHomeScreen, "TutorHomeScreen"),
}
/* eslint-enable @typescript-eslint/no-require-imports */
